<script>
  import { query, subscribe } from "svelte-apollo";
  import { _ as t } from "svelte-i18n";
  import * as R from "ramda";

  import { client } from "apollo.js";
  import {
    LAWCASE_CLIENT_QUERY,
    LAWCASE_DOCUMENT_SUBSCRIPTION,
  } from "./queries";
  import Breadcrumbs from "components/Breadcrumbs.svelte";

  import Tabs from "components/Tabs.svelte";
  import TimelineTab from "./TimelineTab.svelte";
  import DocumentsTab from "./DocumentsTab.svelte";

  export let lawcaseId;

  let links = [null];

  const lawcase = query(client, {
    query: LAWCASE_CLIENT_QUERY,
    variables: { lawcaseId },
  });

  const sub = subscribe(client, {
    query: LAWCASE_DOCUMENT_SUBSCRIPTION,
    variables: { lawcaseId },
  });

  sub.subscribe((result) => {
    result.then(({ data }) => {
      console.log(data);
    });
  });

  let items = [];
  let folders = [];
  let documents = [];

  lawcase.result().then((r) => {
    folders = r.data.lawcaseClient.folders;
    documents = r.data.lawcaseClient.documents;

    links = [
      {
        to: `lawcase/${lawcaseId}/folders`,
        label: `${r.data.lawcaseClient.title}`,
      },
    ];

    // Map events
    const events = r.data.lawcaseClient.events.map((e) => ({
      ...e,
      icon: e.category === "Extra - Judge" ? "handshake" : "law",
    }));

    // Sort by relevant date
    items = events.sort((a, b) => new Date(b.date) - new Date(a.date));

    // Append initial element
    items = R.append(
      {
        id: `lawcase-${lawcaseId}`,
        title: r.data.lawcaseClient.title,
        date: r.data.lawcaseClient.insertedAt,
        icon: "case",
        __typename: "Lawcase",
      },
      items,
    );
  });

  $: panes = [
    {
      relUrl: "",
      component: TimelineTab,
      label: $t("content.events"),
      props: { lawcaseId, items },
    },
    {
      relUrl: "folders",
      component: DocumentsTab,
      label: $t("content.documents"),
      props: { lawcaseId, folders, documents },
    },
  ];

  const baseUrl = `/lawcase/${lawcaseId}/`;
</script>

<div class="container">
  <section class="wrapper">
    <div class="breadcrumb">
      <Breadcrumbs {links} />
    </div>
    <Tabs {panes} {baseUrl} />
  </section>
</div>

<style>
  .container {
    width: 100%;
    font-weight: 400;
  }

  .wrapper {
    margin: 0 auto;
    max-width: 1020px;
    height: 100%;
    display: flex;
    flex-direction: column;
  }
</style>
